var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYuyin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 4.2a2.2 2.2 0 014.4 0v3.2a2.2 2.2 0 11-4.4 0V4.2zM12.7 7.4A4.7 4.7 0 018 12.1m0 0a4.7 4.7 0 01-4.7-4.7M8 12.1v2.4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yuyin.eb6b9463.svg";
export { SvgTongyongYuyin as ReactComponent };